import { createElement } from 'react';
import { theme } from '@frontend/theme';
import { useContentComposer } from '../content-composer-provider';
import { isComposerSection } from '../utils/is-composer-section';

export const Toolbox = () => {
  const { parts } = useContentComposer();

  return (
    <div
      className='composer-toolbox'
      css={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        gap: theme.spacing(2),
        padding: theme.spacing(2),
      }}
    >
      {Object.entries(parts).map(([key, Part]) => {
        if (isComposerSection(Part)) {
          return Part.craft.related.tool ? createElement(Part.craft.related.tool, { key }) : null;
        }
        return <Part key={key} />;
      })}
    </div>
  );
};
